/* eslint-disable */

import axios from "axios";
require("../../config/development");
import Vue from "vue";

import moment from "moment";

const state = {
  videoData: [],
  loading: false,
  fileUrl: null,
  userVideoData: null,
  copyUserVideoData: null,
  pdf: null,
  cancelChanges: false,
  videoStatus: null,
  croppedImgUrl: null,
  sortByCreatedDate:null,
  sortByUpdatedDate:null,
  tabs: [
    {
      name: "Personal",
      checkDetails: {
        name: false,
        dob: false,
      },
      isReject: true
    },
    {
      name: "Address",
      checkDetails: { address_status: false , address_validity: false},
      isReject: true
    },
    {
      name: "IPV",
      checkDetails: { gender: false, video: false },
      isReject: true
    },
    { name: "Approve", isReject: true }
  ]
};
const self = Vue.app;
// getters
const getters = {
  getDetailsVideo: state => {
    return state.userVideoData;
  },
  getIpvPdfURl: state => {
    return state.pdf;
  },

  getVideoDetailsById: state => id => {
    return state.videoData.find(element => element.id === id);
  },

  getFilterVideoInfoByStatus: state => status => {
    return state.videoData.filter(
      element => element.kyc_form_check_status === status
    );
  }
};

// actions
const actions = {
  fetchVideoData(context, payload) {
    let api = '';
    if(payload == 'submitted') {
      api = 'submitted_kyc_details'
    } else if(payload == 'rejected') {
      api = 'rejected_kyc_details'
    } else {
      api = 'unverified_kyc_details'
    }

    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }
    context.commit("toggleLoading", true);
    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/ipv.json`
      )
      .then(response => {
        console.log("ipvData res", response.data)
        let data = {
          id: "",
          name: "",
          PAN_number: "",
          createdAt: "",
          updatedAt: "",
          email: ""
        }
        context.commit("saveDetailsVideo", response);
        context.commit("toggleLoading", false);
      })
      .catch(function(err) {
        context.commit("toggleLoading", false);

        return new Promise((resolve, reject) => reject());
      });
  },

  async videoDetailsByID(context, id) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }

    return axios
      .get(
        `${end_point}/admin/adfes433fkdfggs343434/ipv/${id}.json`
      )
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Data is loaded successfully",
          succesFlag: true
        });
        // context.commit("setNotifyFlag", true);
        context.commit("saveUserVideoData", response.data);
        context.commit("saveCopyUserVideoData", response.data);
        return response;
      })
      .catch(function() {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in fetching data..",
          succesFlag: false
        });
      });
  },

  ipvfetchPdf(context, payload) {
    try{
      let admin_partner = context.rootGetters.admin_partner
      let end_point = Vue.config.EL_DORADO_API_URL
      if (admin_partner == "az"){
          end_point = Vue.config.EL_DORADO_API_URL_BIGCO
        }          
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "PDF is loaded successfully",
          succesFlag: true
        });
        let redirect_uri =
          end_point +
          `/admin/adfes433fkdfggs343434/ipv/${payload.id}/${payload.key}.pdf?auth_token=${Vue.vueAuth.getToken()}`;
        window.open(redirect_uri, "_blank");
        context.commit("savePDFUrl", redirect_uri);
      } catch(err) {
        console.log("err in pdf",err)
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in loading pdf..",
          succesFlag: false
        })
      };
  },

  getUrlToken(context) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }   
    return axios
      .get(`${end_point}//api/v3/user/get_token.json`)
      .then(response => new Promise((resolve, reject) => resolve(response)))
      .catch(err => new Promise((resolve, reject) => reject(err)));
  },
  uploadFile(context, payload) {
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    let formdata = new FormData();
    formdata.append("attachment", payload.file);
    formdata.append("type", payload.file.type);
    axios
      .put(`${end_point}/admin/adfes433fkdfggs343434/upload/file.json`, formdata)
      .then(response => {
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully upload pdf..",
          succesFlag: true
        });
        let cvl = {
          status: "",
          remarks: "",
          cvl_audit: {
            personal: {
              pan_status: "",
              name: ""
            },
            ipv: {
              gender: "",
              video: ""
            },
            address: {
              address_status: ""
            },
            kyc: {}
          }
        };
        if (
          payload.key == "file_signature" ||
          payload.key === "file_kyc_form"
        ) {
          if (payload.key === "file_kyc_form")
            context.commit("saveFileURL", response.data.file_url);
          cvl.cvl_audit.kyc[payload.key] = response.data.file_url;
        } else {
          cvl.cvl_audit.ipv[payload.key] = response.data.file_url;
        }

        context.dispatch("submitVideoQuery", { data: cvl, id: payload.id });
        context.commit("updateVideoDetail", payload);
      })
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error in uploading pdf..",
          succesFlag: false
        })
      );
  },
  async uploadImage(context,payload){
    let obj = {name: payload.name,image: payload.image,type:payload.key}
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }       
    return axios
    .put(`${end_point}/admin/adfes433fkdfggs343434/upload/image.json`, obj)
    .then(response => {
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Successfully upload image..",
        succesFlag: true
      });
      let cvl = {
        status: "",
        remarks: "",
        cvl_audit: {
          personal: {
            pan_status: "",
            name: ""
          },
          ipv: {
            gender: "",
            video: ""
          },
          address: {
            address_status: ""
          },
          kyc: {}
        }
      };
      if (
        payload.key == "file_signature" ||
        payload.key === "file_kyc_form"
      ) {
        if (payload.key === "file_kyc_form")
          context.commit("saveFileURL", response.data.file_url);
        cvl.cvl_audit.kyc[payload.key] = response.data.file_url;
      } else {
        cvl.cvl_audit.ipv[payload.key] = response.data.file_url;
      }

      context.dispatch("submitVideoQuery", { data: cvl, id: payload.id });
      context.commit("updateVideoDetail", payload);
      console.log(response,'inupload')
      return response;
    })
    .catch(() =>
      context.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Error in uploading image..",
        succesFlag: false
      })
    );
  },
  updateVideoDetail(context, payload) {
    let obj = {};
    let videoData = payload.data;
    let cvl = {
      status: "",
      remarks: "",
      cvl_audit: {
        personal: {
          pan_status: "",
          name: ""
        },
        ipv: {
          gender: "",
          video: ""
        },
        address: {
          address_status: ""
        },
        kyc: videoData
      }
    };
    obj.data = cvl;
    obj.id = payload.id;
    context
      .dispatch("submitVideoQuery", obj)
      .then(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Successfully update IpvInfo..",
          succesFlag: true
        })
      )
      .catch(() =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Error while updating IpvInfo..",
          succesFlag: false
        })
      );
  },
  submitVideoQuery(context, payload) {
    console.log({submitdata:payload})
    let data = { ipv: payload.data };
    let admin_partner = context.rootGetters.admin_partner
    let end_point = Vue.config.EL_DORADO_API_URL
    if (admin_partner == "az"){
      end_point = Vue.config.EL_DORADO_API_URL_BIGCO
    }      
    return axios
      .put(
        `${end_point}/admin/adfes433fkdfggs343434/ipv/${payload.id}.json`,
        data
      )
      .then(response => {
        context.dispatch("videoDetailsByID", payload.id);
        Promise.resolve(response);
      })
      .catch(err => Promise.reject(err));
  }
};

// mutations
const mutations = {
  saveDetailsVideo(state, payload) {
    console.log("payload", payload)
    state.videoData = payload.data.data;
  },
  toggleLoading(state, flag) {
    state.loading = flag;
  },

  saveFileURL(state, payload) {
    state.fileUrl = payload;
  },
  savePDFUrl(state, payload) {
    state.pdf = payload;
  },

  saveUserVideoData(state, payload) {
    state.userVideoData = payload;
  },
  saveCopyUserVideoData(state, payload) {
    let data = JSON.parse(JSON.stringify(state.userVideoData));

    state.copyUserVideoData = data;
  },

  updateVideoDetail(state, payload) {
    state.userVideoData[payload.key] = payload.value;
  },

  setVideoStatus(state, payload) {
    state.videoStatus = payload;
  },
  cancelChanges(state) {
    let data = JSON.parse(JSON.stringify(state.copyUserVideoData));
    console.log(data)
    state.userVideoData = data;
  },
  removeUserDetails(state) {
    state.userVideoData = null;
    state.copyUserVideoData = null;
  },
  setcroppedImgUrl(state, payload) {
    state.croppedImgUrl = payload;
  },
  setSortingByDate(state,payload){
    let data = Object.keys(payload)[0];
    state[data] = payload[data];
  },
  toggleRejectVideo(state,payload){
    state.tabs[payload.index].isReject = payload.value;
  },
  toggleCheckBoxVideo(state,payload){
    state.tabs[payload.index].checkDetails[payload.element] = payload.value
  },
  resetVideoTab(state){
    state.tabs = [
      {
        name: "Personal",
        checkDetails: {
          name: false,
          dob: false,
        },
        isReject: true
      },
      {
        name: "Address",
        checkDetails: { address_status: false , address_validity: false},
        isReject: true
      },
      {
        name: "IPV",
        checkDetails: { gender: false, video: false },
        isReject: true
      },
      { name: "Approve", isReject: true }
    ]
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
